module.exports = __webpack_public_path__ + "static/closing-more-sale-faster-aa6e6a9908fec2f7ded1e2462966b67d.png";